import React from "react";
import SantaClara from "../components/SantaClara";
import JumpSantaClara from "../components/JumpSantaClara";
import SantaClaraFAQs from "../components/SantaClaraFAQs";
import ReviewsSlider from "../components/ReviewsSlider";

function SantaClaraCA() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content="Need Junk Removal Service in Santa Clara, CA? Junk Droid offers same-day service, free estimates, and eco-friendly disposal. Call now!"
        />
        <base href="/" />

        <link
          rel="preload"
          as="image"
          href="/assets/img/Junk-Removal-Santa-Clara.webp"
          type="image/webp"
        />
        <link rel="canonical" href="https://junkdroid.com/santaclaraca/" />

        <title>Junk Removal Santa Clara, CA | Junk Droid</title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      {/*  */}

      <SantaClara />
      {/* ================== Hero Section Start HERE =========================  */}
      <div className="container-fluid p-0 madeesay-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#">Location</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Santa Clara, CA
                  </li>
                </ol>
              </nav>
              <h1>
                Junk Removal <span>In Santa Clara</span>
              </h1>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <div className="inner-img">
                <img
                  src="/assets/img/Junk-Removal-Santa-Clara.webp"
                  alt="Santaclara"
                />
              </div>
              <p>
                Need junk removal in santa clara? Our team removes unwanted
                items quickly and efficiently, leaving you with a clean and
                clutter-free space.
              </p>
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 booking-btn">
                  <a href="/book-online/">
                    <button type="button" className="btn btn-book">
                      Book Appointment{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-calendar"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                      </svg>
                    </button>
                  </a>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6 rate-sect">
                  <h4>Rated 5.0 on Google</h4>
                  <div className="rating-sec">
                    <span>5.0</span> &nbsp;&nbsp;
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-star-fill ms-0"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-star-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-star-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-star-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-star-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 desk-img">
              <img
                src="/assets/img/Junk-Removal-Santa-Clara.webp"
                alt="Santaclara"
              />
            </div>
          </div>
        </div>
        <hr className="mb-0" />
      </div>
      {/* ================== Hero Section End HERE =========================  */}

      {/* ================== Trusted Services Section Start HERE =========================  */}
      <JumpSantaClara />
      {/* ================== Trusted Services Section Ended HERE =========================  */}

      {/* ================== Top Rated Reviews Section Start HERE =========================  */}
      <ReviewsSlider />
      {/* ================== Top Rated Reviews Section End HERE =========================  */}
      {/* ================== FAQ's Section Start HERE =========================  */}
      <div className="container-fluid faqs-junk">
        <div className="container faq-sec">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h2>
                  Frequently <span>Asked Questions</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="4"
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              {/* =========== FAQ ============== */}
              <SantaClaraFAQs />
              {/* ======== FAQ */}
            </div>
          </div>
        </div>
        {/* =========== Booking Section Start From Here ============= */}
        <div className="container upr-footer up-footer booking-footer">
          <div className="row">
            <div className="col-md-12">
              <h2>Book Online and Save $20</h2>
              <h6>
                We’ll do all the lifting and loading, plus clean up any mess
                afterwards
              </h6>
              <center>
                <a href="/book-online/">
                  <button type="button" className="btn up-footer-btn">
                    SCHEDULE ONLINE &nbsp;
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  </button>
                </a>
              </center>
            </div>
          </div>
        </div>
        {/* =========== Booking Section Ended From Here ============= */}
      </div>
      {/* ================== FAQ's Section End HERE =========================  */}
    </div>
  );
}

export default SantaClaraCA;
